import { render } from "./ContainerLogs.vue?vue&type=template&id=38109702&scoped=true"
import script from "./ContainerLogs.vue?vue&type=script&lang=js"
export * from "./ContainerLogs.vue?vue&type=script&lang=js"

import "./ContainerLogs.vue?vue&type=style&index=0&id=38109702&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38109702"]])

export default __exports__